import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filtergrp',
    standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, allApps: any[]): any[] {
    if (!allApps) return [];
    if (!searchText) return items;
    if(searchText == '') return [];
    if(allApps.length > 0) {
      return allApps.filter(item => {
        return Object.keys(item).some(key => {
          return String(item[key]).toLowerCase().includes(searchText.toLowerCase());
        });
      });
    }
    else {
      return items.filter(item => {
        return Object.keys(item).some(key => {
          return String(item[key]).toLowerCase().includes(searchText.toLowerCase());
        });
      });
    }
   }

}
